module.exports = __webpack_public_path__ + "static/img/risk_04_2025.3036c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk/risk_04_2025.jpg
// module id = 3Hub
// module chunks = 98